<template>
  <div>
    <h1>Отчеты</h1>
    <button class="open-modal-btn" @click="openModal">Выгрузить сводный отчет по ДО</button>

    <div class="row g-3">
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="searchParams.katoCode"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="bin" class="form-label col-md-3">БИН</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" class="form-control" id="bin" v-model="searchParams.bin">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="lmsId" class="form-label col-md-3">LMS ID</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="text" class="form-control" id="lmsId" v-model="searchParams.lmsId">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" max="12" class="form-control" id="accountingMonth" v-model="searchParams.accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min="2024" class="form-control" id="accountingYear" v-model="searchParams.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="dateTo" class="form-label col-md-3">Дата выгрузки отчета с:</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="date" class="form-control" id="dateTo" v-model="searchParams.reportDateFrom">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="dateFrom" class="form-label col-md-3">Дата выгрузки отчета до:</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="date" class="form-control" id="dateFrom" v-model="searchParams.reportDateTo">
            </div>
          </div>
        </div>

        <div class="row col-md-7">
          <div class="el-input-group">
            <button class="btn btn-primary" @click="fetchReports(true)">Поиск</button>
            <button class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
          </div>
        </div>
      </div>
    </div>
    <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParams.pageSize"></b-pagination>

    <!-- Попап окно -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>Выберите месяц и год</h2>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="accountingMonth">БИН:</label>
            <input
              type="text"
              id="bin"
              v-model="bin"
            />
          </div>

          <div class="form-group">
            <label for="accountingMonth">LMS ID:</label>
            <input
                type="text"
                id="bin"
                v-model="lmsId"
            />
          </div>

          <multiselect
              v-model="kato"
              :options="katoList"
              :searchable="true"
              :closeOnSelect="true"
              :custom-label="formattedKatoLabel"
              placeholder="Выберите Като"
              :multiple="false"
              :clear-on-select="true"
          />


          <div class="form-group">
            <label for="accountingMonth">Месяц:</label>
            <input
              type="number"
              id="accountingMonth"
              v-model="accountingMonth"
              min="1"
              max="12"
              required
            />
          </div>

          <div class="form-group">
            <label for="accountingYear">Год:</label>
            <input
              type="number"
              id="accountingYear"
              v-model="accountingYear"
              min="2000"
              required
            />
          </div>

          <button type="submit" class="submit-btn" :disabled="isLoading">
            {{ isLoading ? 'Выгружается...' : 'Выгрузить' }}
          </button>
        </form>
        <button class="close-modal-btn" @click="closeModal">Закрыть</button>
      </div>
    </div>

    <!-- Таблица отчетов -->
    <table class="reports-table">
      <thead>
      <tr>
        <th>Имя файла</th>
        <th>БИН</th>
        <th>LMS ID</th>
        <th>Расчетный месяц и год</th>
        <th>Населенный пункт</th>
        <th>Статус</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(report, index) in reports" :key="index">
        <td>
          <a
            v-if="report.reportStatus === 'GENERATED'"
            @click="handleDownload(report.uuid, report.fileName)"
            :class="{ 'active-link': report.reportStatus === 'GENERATED', 'error-link': report.reportStatus === 'ERROR' }"
          >
            {{ report.fileName }}
          </a>
          <span
            v-else
            :class="{ 'inactive-link': report.reportStatus !== 'GENERATED', 'error-link': report.reportStatus === 'ERROR' }"
          >
            {{ report.fileName }}
          </span>
        </td>
        <td>{{ report.bin }}</td>
        <td>{{ report.lmsId }}</td>
        <td>{{ report.accountingMonth }}.{{ report.accountingYear }}</td>
        <td>{{ getKatoName(report.katoCode).nameRu }}</td>
        <td :class="getStatusClass(report.reportStatus)" >
          {{ translateStatus(report.reportStatus) }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref, onMounted, computed, reactive, watch} from "vue";
import { generateSummaryReport, getReportList, downloadReportFile } from "@/services/reportService";
import { ReportSearchParam , Report } from "@/types/report";
import {PageResponse} from "@/types/pageResponse";
import Multiselect from "vue-multiselect";
import {Kato} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import {SearchParam} from "@/types/searchParam";

export default defineComponent({
  components: {Multiselect},
  setup() {
    const pageResponse = ref<PageResponse<Report>>();
    const showModal = ref(false);
    const accountingMonth = ref<number | null>(null);
    const accountingYear = ref<number | null>(null);
    const bin = ref<string | null>("");
    const lmsId = ref<string | null>(null);
    const kato = ref<Kato | null>(null);
    const isLoading = ref(false);
    const reports = ref<Report[]>([]);
    const currentPage = ref(1);
    const page = ref(1);
    const pageSize = ref(10);
    const searchParams = reactive(new ReportSearchParam());
    searchParams.reportType = "SUMMARY_REPORT";
    const katoList = ref<Kato[]>([]);

    const fetchCachedDatas = async () => {
      katoList.value = await cacheService.useKatoStore().fetchKato();
    };

    const fetchReports = async (isPageDefault: boolean = false) => {
      try {
        if (isPageDefault) {
          searchParams.page = 0;
          currentPage.value = 1;
        }
        const token = localStorage.getItem("access_token");
        let filter: Record<string, any> = {};
        if (searchParams.katoCode) {
          filter['katoCode'] = ""+searchParams.katoCode.code;
        }
        if (searchParams.accountingMonth) {
          filter['accountingMonth'] = ""+searchParams.accountingMonth;
        }
        if (searchParams.accountingYear) {
          filter['accountingYear'] = ""+searchParams.accountingYear;
        }
        if (searchParams.bin) {
          filter['bin'] = ""+searchParams.bin;
        }
        if (searchParams.lmsId) {
          filter['lmsId'] = searchParams.lmsId;
        }
        if (searchParams.reportDateFrom) {
          filter['dateFrom'] = searchParams.reportDateFrom;
        }
        if (searchParams.reportDateTo) {
          filter['dateTo'] = searchParams.reportDateTo;
        }
        filter['reportType'] = 'SUMMARY_REPORT';
        const searchParam:SearchParam = new SearchParam(searchParams.pageSize, searchParams.page, filter, {});
        if (token) {
          pageResponse.value  = await getReportList(searchParam);
          reports.value = pageResponse.value.content;
        }
      } catch (error) {
        console.error("Ошибка при получении списка отчетов:", error);
      }
    };

    // Открытие модального окна
    const openModal = () => {
      showModal.value = true;
    };

    // Закрытие модального окна
    const closeModal = () => {
      showModal.value = false;
      accountingMonth.value = null;
      accountingYear.value = null;
      bin.value = "";
    };

    // Отправка формы для создания отчета
    const handleSubmit = async () => {
      isLoading.value = true;

      try {
        const token = localStorage.getItem("access_token");
        if (token && accountingMonth.value !== null && accountingYear.value !== null && kato.value != null) {
          let filter: Record<string, any> = {};
          if (kato.value) {
            filter['katoCode'] = ""+kato.value.code;
          }
          if (accountingMonth.value) {
            filter['accountingMonth'] = ""+accountingMonth.value;
          }
          if (accountingYear.value) {
            filter['accountingYear'] = ""+accountingYear.value;
          }
          if (bin.value) {
            filter['bin'] = ""+bin.value;
          }
          if (lmsId.value) {
            filter['lmsId'] = lmsId.value;
          }
          const searchParam:SearchParam = new SearchParam(searchParams.pageSize, searchParams.page, filter, {});
          await generateSummaryReport(searchParam).then(() => {
            closeModal();
            window.location.reload();
          });
        }
      } catch (error) {
        console.error("Ошибка при выгрузке отчета:", error);
      } finally {
        isLoading.value = false;
      }
    };

    // Перевод статуса на русский
    const translateStatus = (status: string): string => {
      switch (status) {
        case "GENERATING":
          return "Файл в процессе";
        case "GENERATED":
          return "Файл создан";
        case "ERROR":
          return "Неизвестная ошибка";
        default:
          return "Неизвестно";
      }
    };

    const handleDownload = async (fileId: string, fileName: string) => {
      try {
        const token = localStorage.getItem("access_token");
        if (token) {
          await downloadReportFile(token, fileId, fileName);
        }
      } catch (error) {
        console.error("Ошибка при скачивании файла:", error);
      }
    };

    const getStatusClass = (status: string): string => {
      if (status === "GENERATED") return "status-generated";
      if (status === "ERROR") return "status-error";
      return "";
    };

    // Загрузка отчетов при монтировании компонента
    onMounted(() => {
      fetchReports();
      fetchCachedDatas();
    });

    watch(currentPage, (newPage) => {
      searchParams.page = newPage - 1;
      fetchReports();
    });

    const formattedKatoLabel = (item: any) => {
      return `${item.code} | ${item.nameRu}`;
    };

    const getKatoName = (code: number) => {
      return katoList.value.find(kato => kato.code === code);
    }

    const clearSearchParam = () => {
      searchParams.reportType = "SUMMARY_REPORT";
      searchParams.accountingMonth = null;
      searchParams.accountingYear = null;
      searchParams.bin = null;
      searchParams.lmsId = null;
      searchParams.reportDateFrom = null;
      searchParams.reportDateTo = null;
      searchParams.katoCode = null;
    }

    return {
      showModal,
      accountingMonth,
      accountingYear,
      bin,
      lmsId,
      kato,
      isLoading,
      reports,
      openModal,
      closeModal,
      handleSubmit,
      translateStatus,
      handleDownload,
      getStatusClass,
      currentPage,
      pageSize,
      searchParams,
      fetchReports,
      pageResponse,
      katoList,
      formattedKatoLabel,
      getKatoName,
      clearSearchParam,
    };
  }
});
</script>

<style scoped>
h1 {
  text-align: center;
  margin-top: 20px;
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}

.reports-table {
  width: 100%;
  margin: 20px 0;
  border-collapse: collapse;
}

.reports-table th,
.reports-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.reports-table th {
  background-color: #4caf50;
  color: white;
}

.active-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

.active-link:hover {
  text-decoration: underline;
}

.inactive-link {
  color: gray;
}

.error-link {
  color: red;
}

</style>